import { Card } from "../ui/card";
import type { AccountRole, ManagedUser, UserSummary, ConvertibleAccountType } from "./types";
import type { Trial } from "./trials-api";
import { UserTable } from "./UserTable";
import { Pagination } from "./Pagination";

type DirectoryCardProps = {
  users: ManagedUser[];
  total: number;
  summary: UserSummary;
  showingFrom: number;
  showingTo: number;
  page: number;
  totalPages: number;
  totalLabel?: string;
  pageLabel?: string;
  hasNextPage?: boolean;
  isLoading: boolean;
  actionUserId: string | null;
  hasSearch: boolean;
  trials?: Map<string, Trial>;
  onPageChange: (page: number) => void;
  onClearSearch: () => void;
  onEdit: (user: ManagedUser) => void;
  onResetPassword: (user: ManagedUser) => void;
  onRevokeSessions: (user: ManagedUser) => void;
  onAccountRoleChange: (userId: string, role: AccountRole) => void;
  onAccountTypeChange: (userId: string, type: ConvertibleAccountType) => void;
  onBanToggle: (user: ManagedUser) => void;
  onDelete: (user: ManagedUser) => void;
};

export const DirectoryCard = ({
  users,
  total,
  summary,
  showingFrom,
  showingTo,
  page,
  totalPages,
  totalLabel,
  pageLabel,
  hasNextPage,
  isLoading,
  actionUserId,
  hasSearch,
  trials,
  onPageChange,
  onClearSearch,
  onEdit,
  onResetPassword,
  onRevokeSessions,
  onAccountRoleChange,
  onAccountTypeChange,
  onBanToggle,
  onDelete,
}: DirectoryCardProps) => {
  return (
    <Card className="flex min-h-0 flex-1 flex-col overflow-hidden border shadow-sm">
      <UserTable
        users={users}
        actionUserId={actionUserId}
        summary={summary}
        isLoading={isLoading}
        hasSearch={hasSearch}
        trials={trials}
        onEdit={onEdit}
        onResetPassword={onResetPassword}
        onRevokeSessions={onRevokeSessions}
        onAccountRoleChange={onAccountRoleChange}
        onAccountTypeChange={onAccountTypeChange}
        onBanToggle={onBanToggle}
        onDelete={onDelete}
        onClearSearch={onClearSearch}
      />
      <Pagination
        page={page}
        totalPages={totalPages}
        showingFrom={showingFrom}
        showingTo={showingTo}
        total={total}
        totalLabel={totalLabel}
        pageLabel={pageLabel}
        hasNextPage={hasNextPage}
        onPageChange={onPageChange}
      />
    </Card>
  );
};
